import { render, staticRenderFns } from "./agv-add-to-order-button.vue?vue&type=template&id=59dd404c&scoped=true&lang=pug&"
import script from "./agv-add-to-order-button.vue?vue&type=script&lang=js&"
export * from "./agv-add-to-order-button.vue?vue&type=script&lang=js&"
import style0 from "./agv-add-to-order-button.vue?vue&type=style&index=0&id=59dd404c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dd404c",
  null
  
)

export default component.exports